var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "confirmation-container-wrapper" },
    [
      _vm.updateGuide ? _c("div", { staticClass: "updateGuide" }) : _vm._e(),
      _c("div", { staticClass: "__flex-con" }, [
        _c("div", { staticClass: "confirmation-header" }, [
          _c(
            "div",
            { staticClass: "detail-header" },
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("confirmation_title")) +
                    "\n                "
                ),
              ]),
              _c(
                "div",
                { staticClass: "guide-tip" },
                [
                  _c("svg-icon", {
                    attrs: {
                      "icon-name": "icon-guidance",
                      size: 28,
                      "icon-color": "#00b8f5",
                    },
                  }),
                ],
                1
              ),
              false
                ? _c("GuidanceTooltip", {
                    attrs: {
                      content: _vm.confirmationTip,
                      jumpLink: _vm.$t(
                        `confirmation.details_list.confirmationTipLink_${_vm.getUser.userType}`
                      ),
                      size: 20,
                      iconSize: 15,
                      placement: "right",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c("ul", { staticClass: "ul-container" }, [
            _c(
              "div",
              {
                class:
                  _vm.updateGuide && _vm.updateGuideStep === 5
                    ? "updateGuideIcon"
                    : "",
              },
              [
                _c(
                  "li",
                  { staticClass: "active", on: { click: _vm.openDashbard } },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("confirmation.homepage.tab.dashboard")) +
                        "\n                        "
                    ),
                    _c("div", {
                      class: ["new-tag", `new_${_vm.$i18n.locale}`],
                    }),
                  ]
                ),
                _vm.updateGuide && _vm.updateGuideStep === 5
                  ? _c(
                      "div",
                      { staticClass: "updateGuideTip" },
                      [
                        _c("div", { staticClass: "margin-bottom-10" }, [
                          _vm._v("5/5"),
                        ]),
                        _c("div", { staticClass: "margin-bottom-10" }, [
                          _vm._v(_vm._s(_vm.$t("confirmation_bubble_5"))),
                        ]),
                        _c(
                          "el-button",
                          {
                            staticClass: "guide-btn",
                            on: { click: _vm.gotItClick },
                          },
                          [_vm._v(_vm._s(_vm.$t("gotIt")))]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
          ]),
        ]),
        _c(
          "div",
          {
            staticClass: "__tips mb-10",
            on: {
              click: function ($event) {
                _vm.show2 = !_vm.show2
              },
            },
          },
          [
            _c(
              "div",
              { staticStyle: { display: "flex", "align-items": "center" } },
              [
                _c("div", {
                  staticClass: "guide-content-container",
                  domProps: { innerHTML: _vm._s(_vm.confirmationTip) },
                }),
                _c("i", {
                  class: [
                    _vm.show2 ? "el-icon-arrow-up" : "el-icon-arrow-down",
                  ],
                }),
              ]
            ),
            _c("transition", { attrs: { name: "el-zoom-in-top" } }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.show2,
                      expression: "show2",
                    },
                  ],
                },
                [
                  _c("div", {
                    domProps: { innerHTML: _vm._s(_vm.subConfirmationTip) },
                  }),
                  _c("div", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("confirmation.details_list.dianzi")
                      ),
                    },
                  }),
                ]
              ),
            ]),
          ],
          1
        ),
        _c(
          "div",
          {
            class: [
              "confirmation-content",
              _vm.screenWidth < 1920
                ? "small"
                : _vm.screenWidth == 1920
                ? "medium"
                : "large",
              _vm.$i18n.locale === "zh" ? "zh-cls" : "en-cls",
            ],
          },
          [
            _c("NewComments", {
              attrs: { messageType: "11", siteId: _vm.siteId },
            }),
            _c("DetailList", {
              ref: "detailList",
              staticClass: "content1 content-with-comments",
              attrs: {
                updateGuide: _vm.updateGuide,
                updateGuideStep: _vm.updateGuideStep,
                nextClick: _vm.nextClick,
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.showDashboard,
            direction: "rtl",
            "custom-class": "dashboard-drawer",
            "append-to-body": "",
            "destroy-on-close": "",
            size: _vm.collapseDashboard ? "30%" : "80%",
            modal: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showDashboard = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function () {
                return [
                  _c("div", { staticClass: "confirmation-header-title" }, [
                    _vm._v(_vm._s(_vm.$t("confirmation_dashboard_title"))),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [_c("div", { staticClass: "content2" }, [_c("dashboard")], 1)]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }